export const LOADED_SETTINGS = 'loaded-settings';
export const NOTE_ADDED = 'note-added';
export const NOTE_FOCUSED = 'note-focused';
const loadingReducer = (state, action) => {
  switch (action.type) {
    case LOADED_SETTINGS: {
      return { ...state, settingsLoaded: true };
    }
    case NOTE_ADDED: {
      return { ...state, noteAdded: true };
    }
    case NOTE_FOCUSED: {
      return { ...state, noteAdded: false };
    }
    default:
      return state;
  }
};

export { loadingReducer };
